export enum EnumBanco {
    Safra = 422,
    Itau = 341,
    Caixa = 104,
    BancoBrasil = 1,
    Santander = 33,
    Bradesco = 237
}